<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
                            variant="outlined">
                            <v-icon left>mdi-arrow-left</v-icon>
                            Retour
                        </v-btn>
                        <div class="text-h6 mt-2">Demandes de paiements effectuées sur {{ mainStore.module.base }}
                        </div>
                        <ListPaymentsRequests :key="refresher"></ListPaymentsRequests>

                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ListPaymentsRequests from "@/components/Administration/Payments_Requests/ListPaymentsRequests.vue";

export default {
    components: { ListPaymentsRequests },
    data() {
        return {
            refresher: 0,
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    created() {

    },
};
</script>

<style lang="scss" scoped></style>